import { useNavigation, useRoute } from "@react-navigation/native";
import { useEffect } from "react";
export function usePlacesPickerResult(callback) {
    var setParams = useNavigation().setParams;
    var _useRoute = useRoute(), name = _useRoute.name, params = _useRoute.params;
    useEffect(function() {
        if (params === null || params === void 0 ? void 0 : params._placesPickerResult) {
            var placesPickerResult = params._placesPickerResult;
            // @ts-expect-error
            setParams({
                _placesPickerResult: undefined
            });
            callback(placesPickerResult);
        }
    }, [
        setParams,
        params === null || params === void 0 ? void 0 : params._placesPickerResult,
        callback
    ]);
    return name;
}
